import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { api } from "./api";

const VISITOR_KEY = "pdob_visitor_id";
const HEARTBEAT_MS = 30_000;

function ensureVisitorId() {
  try {
    let v = localStorage.getItem(VISITOR_KEY);
    if (!v) {
      v = (crypto.randomUUID && crypto.randomUUID()) ||
          `v-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
      localStorage.setItem(VISITOR_KEY, v);
    }
    return v;
  } catch {
    return `anon-${Math.random().toString(36).slice(2, 10)}`;
  }
}

async function ping(path, referrer) {
  try {
    await api.post("/analytics/ping", {
      visitor_id: ensureVisitorId(),
      path,
      referrer: referrer || null,
    });
  } catch {
    /* best-effort — never break the UI */
  }
}

/**
 * Global page-view tracker. Fires once when the pathname changes
 * and then every 30s while the page is open (heartbeat).
 * Skips /admin pages so admin browsing doesn't pollute analytics.
 */
export function useAnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    // Skip admin views to keep the traffic panel clean
    if (location.pathname.startsWith("/admin")) return;

    const referrer = document.referrer && !document.referrer.includes(window.location.host)
      ? document.referrer
      : null;

    ping(location.pathname, referrer);
    const id = setInterval(() => ping(location.pathname, referrer), HEARTBEAT_MS);
    return () => clearInterval(id);
  }, [location.pathname]);
}
